export const secrets = {
  cmsApiUserName: 'ck_d96a6d0cc74df6be3e8ea94a20eb28e5b699a143',
  cmsApiUserPassword: 'cs_959cb5a425b7306f6221e03ab2f1d76e060a3d6a',
};
